import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Dayjs } from "dayjs";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";

export interface IReportStateSlice {
  reportsDateFilter: IFilterState;
  aiRiskReportFilter: {
    date: IDateType;
    customDate?: Dayjs | null;
  };
  isRoute?: boolean;
}

const name = "resident";

export const initialState: IReportStateSlice = {
  reportsDateFilter: {
    date: 0,
    customDate: {
      start: null,
      end: null,
    },
  },
  aiRiskReportFilter: {
    date: 1,
    customDate: null,
  },
  isRoute: false,
};

export const reportSlice = createSlice({
  name,
  initialState,
  reducers: {
    setReportFilter(
      state,
      action: PayloadAction<Partial<IReportStateSlice["reportsDateFilter"]>>
    ) {
      state.reportsDateFilter = {
        ...state.reportsDateFilter,
        ...action.payload,
      };
    },

    setAiRiskReportFilter(
      state,
      action: PayloadAction<Partial<IReportStateSlice["aiRiskReportFilter"]>>
    ) {
      state.aiRiskReportFilter = {
        ...state.aiRiskReportFilter,
        ...action.payload,
      };
    },

    setReportState: (
      state,
      action: PayloadAction<Partial<IReportStateSlice>>
    ) => ({
      ...state,
      ...action.payload,
    }),
  },
});

export const { setReportFilter, setReportState, setAiRiskReportFilter } =
  reportSlice.actions;

const persistedReducer = persistReducer(
  {
    key: name,
    storage: storage,
    whitelist: ["reportsDateFilter"],
  },
  reportSlice.reducer
);

export default persistedReducer;
